/* eslint-disable no-unused-vars */
import {
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Box,
	Button,
	Card,
	CardContent,
	FormControl,
	InputLabel,
	IconButton,
	MenuItem,
	Select,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
	useMediaQuery,
	FormControlLabel,
	Link,
	Checkbox,
	Typography,
	CircularProgress,
	Alert,
	Chip,
	Tooltip,
	Divider,
	Autocomplete,
} from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useCart } from "../../context/cartContext";
import { useSite } from "../../context/siteContext";
import { useAuth } from "../../context/authContext";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../components/PageTitle/PageTitle";
import { styled } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DefaultLoader from "../../components/DefaultLoader/DefaultLoader";
import ScheduleOrder from "../../components/ScheduleOrder/ScheduleOrder";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import ComplianceDescriptionModal from "../../components/CompliancePolicy/ComplianceDescriptionModal";
import EulaLibraryModal from "../../components/CompliancePolicy/EulaLibraryModal";
import { openComplianceDocument } from "../../components/CompliancePolicy/complianceUtils";
import { ALERT_MESSAGES, BUTTON, LABELS, MENU_ITEMS, PLACEHOLDER, TABLE_HEADERS, TITLES, UI_TEXT } from "../../constants";
import { Check, Delete, Lan, ScheduleOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { getCustomerByIdForCusSites } from "../../services/scheduleOrderService";
import { getProductsById } from "../../services/cartService";
import { createOrder, getPromotionAvailability, resolveLineDiscounts, validatePromotion } from "../../services/checkoutService";
import NotAuthorized from "../../components/NotAuthorized/NotAuthorized";
import { useOptions } from "../../context/optionContext";
import { useCompliance } from "../../context/complianceContext";
import DocCardImage from "../../components/DocCardImage/DocCardImage";
import OrderFailure from "../OrderFaliure/OrderFaliure";
import { getSiteAddressesNew, createSiteAddress, updateSiteAddress } from "../../services/manageSitesService";
import { toast } from "../../context/ToastContext";
import { DEFAULT_LAYOUT } from "../../config";
import { trackEvent } from "../../utilities/analyticsService";
import {
	followsMultipleSalesOrderQuantity,
	formatOrderQuantity,
	getMinimumSalesOrderQuantity,
	getMultipleSalesOrderQuantity,
	parseOrderQuantity,
} from "../../utilities/orderQuantity";

const SHARED_DELIVERY_TERMS = [
	{ term: 'PPD-ADD', descriptionKey: 'UI_TEXT.PREPAID_AND_ADD', helperText: 'Freight, duties and taxes will be added to the invoice if they apply' },
	{ term: 'EXW', descriptionKey: 'UI_TEXT.COLLECT_ON_DELIVERY' },
];

// Previous Delivery Terms by Legal Entity
// const DT_BY_LE = {
// 	AUSA: [
// 		{ term: 'PPD-ADD', descriptionKey: 'UI_TEXT.PREPAID_AND_ADD', helperText: 'Freight, duties and taxes will be added to the invoice if they apply' },
// 		{ term: 'COD', descriptionKey: 'UI_TEXT.COLLECT_ON_DELIVERY' },
// 	],
// 	ACAN: [
// 		{ term: 'PPD-ADD', descriptionKey: 'UI_TEXT.PREPAID_AND_ADD', helperText: 'Freight, duties and taxes will be added to the invoice if they apply' },
// 		{ term: 'COD', descriptionKey: 'UI_TEXT.COLLECT_ON_DELIVERY' },
// 	],
// 	EUUK: [
// 		{ term: 'EXW', description: 'SHIPPING.EX_WORKS' },
// 		{ term: 'DAP', description: 'SHIPPING.DELIVERY_AT_PLACE' },
// 		{ term: 'DDP', description: 'SHIPPING.DELIVERY_DUTY_PAID' },
// 	],
// };

// Delivery Terms by Legal Entity
const DT_BY_LE = {
	AUSA: SHARED_DELIVERY_TERMS,
	ACAN: SHARED_DELIVERY_TERMS,
	EUUK: SHARED_DELIVERY_TERMS,
};

// Mode of Delivery by Legal Entity
const DM_BY_LE = {
	AUSA: [
		{ code: 'UPS-GND', description: 'UPS Ground' },
		{ code: 'UPS-1DA', description: 'UPS Next Day Air' },
		{ code: 'UPS-1DM', description: 'UPS Next Day Air AM Delivery' },
		{ code: 'UPS-2DA', description: 'UPS Second Day Air' },
		{ code: 'FedEx-FG', description: 'FedEx Ground' },
		{ code: 'FedEx-F2', description: 'FedEx Second Day Air' },
		{ code: 'Speci-Spec', description: 'Special Instructions' },
	],
	ACAN: [
		{ code: 'UPS-GND', description: 'UPS Ground' },
		{ code: 'UPS-1DA', description: 'UPS Next Day Air' },
		{ code: 'UPS-1DM', description: 'UPS Next Day Air AM Delivery' },
		{ code: 'UPS-2DA', description: 'UPS Second Day Air' },
		{ code: 'FedEx-FG', description: 'FedEx Ground' },
		{ code: 'FedEx-F2', description: 'FedEx Second Day Air' },
		{ code: 'Speci-Spec', description: 'Special Instructions' },
	],
	EUUK: [
		{ code: 'UPS-1DA', description: 'UPS Next Day Air' },
		{ code: 'UPS-1DM', description: 'UPS Next Day Air AM Delivery' },
		{ code: 'UPS-2DA', description: 'UPS Second Day Air' },
		{ code: 'FedEx-FG', description: 'FedEx Ground' },
		{ code: 'FedEx-F2', description: 'FedEx Second Day Air' },
		{ code: 'Speci-Spec', description: 'Special Instructions' },
	],
};




const roundCurrency = (value) =>
	Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;

const getCartSite = (item, fallbackSite = "") =>
	item?.Site || item?.site_number || fallbackSite;

const toNullableNumber = (value) => {
	const parsed = Number(value);
	return Number.isFinite(parsed) ? parsed : null;
};

const Checkout = () => {
	const { user, hasPermission } = useAuth();
	const { cartItems, clearCart } = useCart();
	const { optionKeys } = useOptions();
	const { items: complianceItems } = useCompliance();
	const { selectedSite, selectedSiteData, siteData, selectedSiteCurrency, currencySymbol, selectedSiteLegalEnitity } = useSite();
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	// Bumped by "chip:navigate" so a same-site re-ask ("go to checkout") retries the product
	// fetch below even though selectedSite/cartItems never actually changed (cart's own
	// refresh_cart doesn't refetch cartItems from the server unless the underlying items
	// changed, and switch_site to the SAME site is a no-op) — without this a page stuck on a
	// stale error from an earlier failed fetch never retries. Mirrors MyMachines.js's
	// identical refreshTick pattern.
	const [refreshTick, setRefreshTick] = useState(0);
	useEffect(() => {
		const onChipNavigate = (e) => {
			if (!String(e?.detail?.path || "").startsWith("/checkout")) return;
			setRefreshTick((n) => n + 1);
		};
		window.addEventListener("chip:navigate", onChipNavigate);
		return () => window.removeEventListener("chip:navigate", onChipNavigate);
	}, []);
	const [selectedCustomer, setSelectedCustomer] = useState(null);
	const [buttonLoading, setButtonLoading] = useState(false);
	const [buttonSuccess, setButtonSuccess] = useState(false);
	const [cartProducts, setCartProducts] = useState([]);
	const [promotionCode, setPromotionCode] = useState("");
	const [appliedPromotion, setAppliedPromotion] = useState(null);
	const [lineDiscountResolution, setLineDiscountResolution] = useState(null);
	const [lineDiscountLoading, setLineDiscountLoading] = useState(false);
	const [promotionError, setPromotionError] = useState("");
	const [promotionLoading, setPromotionLoading] = useState(false);
	const [promotionAvailable, setPromotionAvailable] = useState(false);
	const [isInitialized, setIsInitialized] = useState(false);
	const [termsAccepted, setTermsAccepted] = useState(false);
	const [orderSchedule, setOrderSchedule] = useState(false);
	const [scheduleOpen, setScheduleOpen] = useState(false);
	const [selectedOrderSchedule, setSelectedOrderSchedule] = useState(null);
	const [uploadedFile, setUploadedFile] = useState(null);
	const [dTOptions, setDTOptions] = useState([]);
	const [dMOptions, setDMOptions] = useState([]);
	const { t } = useTranslation();
	const canPlaceOrder = hasPermission("order_management.create_order")
	const orderSchedulesEnabled = optionKeys?.enableOrderSchedules !== "false";
	const canCreateOrderSchedule =
		orderSchedulesEnabled && hasPermission("order_management.create_order_schedules")
	const [expandedPanels, setExpandedPanels] = useState({
		panel1: true,
		panel2: true,
		panel3: true,
	});
	const [orderFailure, setOrderFaliure] = useState(false);
	const [orderFailureData, setOrderFaliureData] = useState(null);
	const [policyModal, setPolicyModal] = useState({ open: false, doc: null });
	const [eulaModalOpen, setEulaModalOpen] = useState(false);
	// Determine current legal entity (fallback to AUSA)
	const legalEntity = selectedSiteLegalEnitity || "AUSA";
	const resolveCurrentSiteId = useCallback(() => {
		if (selectedSiteData?.site_id) return selectedSiteData.site_id;
		return siteData.find((site) => site.customer_site_number === selectedSite)?.site_id || selectedSite;
	}, [selectedSite, selectedSiteData?.site_id, siteData]);

	const buildPromotionAnalyticsPayload = useCallback(
		(validation = {}, fallbackCode = "", extra = {}) => {
			const siteId = resolveCurrentSiteId();

			return {
				promo_code: validation?.promotion?.code || fallbackCode || promotionCode || "",
				promotion_id: validation?.promotion?.id || extra.promotion_id || "",
				discount_amount:
					validation?.summary?.promo_discount ??
					validation?.promotion?.discount_amount ??
					extra.discount_amount ??
					0,
				original_price: extra.original_price ?? 0,
				discounted_price: extra.discounted_price ?? 0,
				discount_percentage: extra.discount_percentage ?? 0,
				price_before_discount: extra.price_before_discount ?? extra.original_price ?? 0,
				price_after_discount: extra.price_after_discount ?? extra.discounted_price ?? 0,
				reason: validation?.reason || extra.reason || "",

				customer_id: selectedSiteData?.cus_id || selectedCustomer?.cus_id || "",
				customer_name:
					selectedSiteData?.parent_customer_name ||
					selectedSiteData?.customer_name ||
					selectedCustomer?.customer_name ||
					"",
				customer_number:
					selectedSiteData?.customer_number ||
					selectedCustomer?.customer_number ||
					"",

				site_id: siteId || selectedSiteData?.site_id || "",
				site_name:
					selectedSiteData?.customer_site_number ||
					selectedSite ||
					selectedSiteData?.customer_site_name ||
					selectedSiteData?.site_name ||
					"",
				site_number:
					selectedSiteData?.customer_site_number ||
					selectedSite ||
					"",
				customer_site_number:
					selectedSiteData?.customer_site_number ||
					selectedSite ||
					"",

				legal_entity: legalEntity,
				site_legal_entity: legalEntity,
				currency: selectedSiteCurrency || "usd",

				order_number: extra.order_number || "",
				order_key: extra.order_key || "",
			};
		},
		[
			legalEntity,
			promotionCode,
			resolveCurrentSiteId,
			selectedCustomer,
			selectedSite,
			selectedSiteCurrency,
			selectedSiteData,
		]
	);
	// Get available delivery terms & modes for this entity
	const deliveryTermsOptions = DT_BY_LE[legalEntity] || DT_BY_LE["AUSA"];
	const deliveryModeOptions = DM_BY_LE[legalEntity] || DM_BY_LE["AUSA"];
	const eulaDocs = useMemo(() => complianceItems?.EULA || [], [complianceItems]);
	const privacyDoc = complianceItems?.PRIVACY || null;
	const termsDoc = complianceItems?.TERMS || null;

	// Define sensible defaults (first item of each list)
	const defaultDeliveryTerm = deliveryTermsOptions[0]?.term || "";
	const defaultModeOfDelivery = deliveryModeOptions[0]?.code || "";

	const [isEditing, setIsEditing] = useState({
		shipping: false,
		billing: false,
	});
	const canEditCheckoutAddresses = optionKeys?.enableCheckoutAddressEditing !== "false";

	// Saved site addresses
	const [shippingAddresses, setShippingAddresses] = useState([]);
	const [billingAddresses, setBillingAddresses] = useState([]);
	const [selectedShippingId, setSelectedShippingId] = useState(null);
	const [selectedBillingId, setSelectedBillingId] = useState(null);
	const [shippingDirty, setShippingDirty] = useState(false);
	const [billingDirty, setBillingDirty] = useState(false);

	// Rename modal for "Save as New Address" using ModalWrapper semantics
	const [renameOpen, setRenameOpen] = useState(false);
	const [renameSection, setRenameSection] = useState(null); // 'shipping' | 'billing'
	const [renameValue, setRenameValue] = useState("");

	const showSnack = (message, severity = "success") => {
		if (!message) return;
		toast.trigger({ message, severity });
	};

	const handlePolicyOpen = useCallback(
		(doc, fallbackUrl) => {
			openComplianceDocument({
				document: doc,
				fallbackUrl,
				onShowDescription: (document) =>
					setPolicyModal({ open: true, doc: document }),
			});
		},
		[]
	);

	const handleEulaView = useCallback(() => {
		if (!eulaDocs.length) {
			openComplianceDocument({
				document: null,
				fallbackUrl: "https://eula.ithena.io/",
				onShowDescription: (document) =>
					setPolicyModal({ open: true, doc: document }),
			});
			return;
		}

		if (eulaDocs.length === 1) {
			openComplianceDocument({
				document: eulaDocs[0],
				fallbackUrl: "https://eula.ithena.io/",
				onShowDescription: (document) =>
					setPolicyModal({ open: true, doc: document }),
			});
			return;
		}
		setEulaModalOpen(true);
	}, [eulaDocs]);

	const fetchSiteAddresses = async (type) => {
		if (!selectedSiteData?.site_id) return [];
		try {
			const resp = await getSiteAddressesNew(selectedSiteData.site_id, type);
			let list = resp?.data?.data ?? resp?.data ?? [];

			// Ensure defaults appear first
			list.sort((a, b) => (b.is_default ? 0 : 1) - (a.is_default ? 0 : 1));

			// If API didn't include defaults for any reason, synthesize on client
			const hasDefault = list.some(a => a.is_default);
			if (!hasDefault) {
				if (type === 'Shipping' && selectedSiteData) {
					list = [{
						id: 'default_shipping',
						is_default: true,
						address_type: 'Shipping',
						address_name: selectedSiteData.address_name_ln || t('UI_TEXT.DEFAULT_SHIPPING'),
						street1: selectedSiteData.street1_ln,
						street2: selectedSiteData.street2_ln,
						street3: selectedSiteData.street3_ln,
						city: selectedSiteData.city_ln,
						state: selectedSiteData.state_ln,
						zip: selectedSiteData.zip_ln,
						country: selectedSiteData.country_ln,
					}, ...list];
				}
				if (type === 'Billing' && selectedCustomer) {
					list = [{
						id: 'default_billing',
						is_default: true,
						address_type: 'Billing',
						address_name: selectedCustomer.address_name_cus || t('UI_TEXT.DEFAULT_BILLING'),
						street1: selectedCustomer.street1_cus,
						street2: selectedCustomer.street2_cus,
						street3: selectedCustomer.street3_cus,
						city: selectedCustomer.city_cus,
						state: selectedCustomer.state_cus,
						zip: selectedCustomer.zip_cus,
						country: selectedCustomer.country_cus,
					}, ...list];
				}
			}

			// Add address_full key to each address object
			list = list.map(addr => {
				const {
					address_name,
					street1,
					street2,
					street3,
					city,
					state,
					zip,
					country
				} = addr;

				// Combine only non-null and non-empty values
				const parts = [address_name, street1, street2, street3, city, state, zip, country]
					.filter(Boolean)
					.join(', ');

				return { ...addr, address_full: parts };
			});

			return list;
		} catch (e) {
			return [];
		}
	};


	const [errors, setErrors] = useState({});
	const isMobile = useMediaQuery("(max-width:600px)");

	const [checkoutDetails, setCheckoutDetails] = useState({
		shipping_address: {
			name: "",
			street: "",
			city: "",
			zip: "",
			country: "",
			state: "",
		},
		billing_address: {
			name: "",
			street: "",
			city: "",
			zip: "",
			country: "",
			state: "",
		},
		additional_details: {
			delivery_terms: defaultDeliveryTerm,
			ship_complete: "true",
			mode_of_delivery: defaultModeOfDelivery,
			freight_number: "",
			order_notes: "",
		},
		payment_details: {
			payment_mode: "PO",
			payment_details: {
				po_number: " ",
				po_file: "",
			},
		},
		order_details: {
			products: [
				{
					product_id: "",
					ProductQty: "",
					ProductPrice: "",
					total: "",
				},
			],
			taxes: "",
			shipping: "",
			discounts: "",
			total: "",
			currency: selectedSiteCurrency || "usd",
		},
	});
	const shouldHideCarrierFields = ["PPD-ADD", "DDP", "DAP"].includes(
		checkoutDetails?.additional_details?.delivery_terms
	);

	const navigate = useNavigate();

	const VisuallyHiddenInput = styled("input")({
		clip: "rect(0 0 0 0)",
		clipPath: "inset(50%)",
		height: 1,
		overflow: "hidden",
		position: "absolute",
		bottom: 0,
		left: 0,
		whiteSpace: "nowrap",
		width: 1,
	});

	const getProductPrice = useCallback(
		(item) => {
			const rawPrice =
				item?.Product?.unit_price_before_discount ??
				item?.Product?.[`original_price_${selectedSiteCurrency}`] ??
				item?.Product?.[`price_${selectedSiteCurrency}`] ??
				item?.Product?.product_sell_price ??
				0;
			const price = Number.parseFloat(rawPrice);
			return Number.isFinite(price) ? price : 0;
		},
		[selectedSiteCurrency]
	);

	const buildCartProductsPayload = useCallback(
		() =>
			cartProducts.map((item) => {
				const price = getProductPrice(item);
				const quantity = Number(item.Quantity || 1);
				return {
					product_id: Number(item.Product?.product_id || item.ProductID),
					machine_id: toNullableNumber(
						item.machine_id ||
						item.MachineID ||
						item.machineId ||
						item.Product?.machine_id ||
						item.Product?.machineId
					),
					machine_number:
						item.machine_number ||
						item.MachineNumber ||
						item.machineNumber ||
						item.Product?.machine_number ||
						item.Product?.machineNumber,
					customer_site_id: Number(
						selectedSiteData?.site_id ||
						item.customer_site_id ||
						item.site_id
					),
					customer_id: Number(
						selectedSiteData?.cus_id ||
						item.customer_id ||
						item.cus_id
					),
					product_name: item.Product?.product_name,
					product_number: item.Product?.product_number,
					ProductQty: quantity,
					ProductPrice: price.toFixed(2),
					total: (quantity * price).toFixed(2),
				};
			}),
		[cartProducts, getProductPrice, selectedSiteData?.cus_id, selectedSiteData?.site_id]
	);

	const getOrderQuantityViolations = useCallback(
		() =>
			cartProducts
				.map((item) => {
					const product = item.Product || item.product_data || {};
					const quantity = parseOrderQuantity(item.Quantity) || 1;
					const minimumQuantity = getMinimumSalesOrderQuantity(product);
					const multipleQuantity = getMultipleSalesOrderQuantity(product);
					const productNumber = product.product_number || item.ProductNumber || item.product_number || item.ProductID;
					if (quantity < minimumQuantity) {
						return `${productNumber}: minimum order quantity is ${formatOrderQuantity(minimumQuantity)}`;
					}
					if (!followsMultipleSalesOrderQuantity(quantity, product)) {
						return `${productNumber}: quantity must follow multiple order quantity ${formatOrderQuantity(multipleQuantity)}`;
					}
					return null;
				})
				.filter(Boolean),
		[cartProducts]
	);

	const buildOrderSummary = useCallback((promotionResult = appliedPromotion, lineDiscountResult = lineDiscountResolution) => {
		const products = buildCartProductsPayload();
		const lineMap = new Map(
			(lineDiscountResult?.lines || []).map((line) => [Number(line.index), line])
		);

		const productsWithLineDiscount = products.map((product, index) => {
			const lineDiscount = lineMap.get(index);
			if (!lineDiscount) return product;

			const discountAmount = roundCurrency(lineDiscount.discount_amount || 0);
			return {
				...product,
				ProductPrice: Number(lineDiscount.unit_price_after_discount ?? product.ProductPrice ?? 0).toFixed(2),
				total: Number(lineDiscount.total_after_line_discount ?? product.total ?? 0).toFixed(2),
				line_discount_applied: discountAmount > 0,
				line_discount_rule_id: lineDiscount.rule?.id || null,
				line_discount_name: lineDiscount.rule?.name || "",
				line_discount_type: lineDiscount.rule?.discount_type || "",
				line_discount_value: lineDiscount.rule?.discount_value || 0,
				line_discount_amount: discountAmount,
				unit_price_before_discount: roundCurrency(lineDiscount.unit_price_before_discount ?? product.ProductPrice ?? 0),
				unit_price_after_discount: roundCurrency(lineDiscount.unit_price_after_discount ?? product.ProductPrice ?? 0),
				total_before_line_discount: roundCurrency(lineDiscount.total_before_line_discount ?? product.total ?? 0),
				total_after_line_discount: roundCurrency(lineDiscount.total_after_line_discount ?? product.total ?? 0),
			};
		});

		const promoLineMap = new Map(
			(promotionResult?.lines || []).map((line) => [Number(line.index), line])
		);

		const productsWithPromotion = productsWithLineDiscount.map((product, index) => {
			const appliedLine = promoLineMap.get(index);
			const promoDiscount = roundCurrency(appliedLine?.discount_amount || 0);
			const totalAfterPromotion = roundCurrency(Number(product.total || 0) - promoDiscount);

			return {
				...product,
				promotion_applied: promoDiscount > 0,
				promo_discount: promoDiscount,
				total_after_promo: totalAfterPromotion,
			};
		});

		const productTotal = roundCurrency(
			products.reduce((total, item) => total + Number.parseFloat(item.total || 0), 0)
		);
		const lineDiscountTotal = roundCurrency(lineDiscountResult?.summary?.line_discount_total || 0);
		const productTotalAfterLineDiscount = roundCurrency(
			productsWithLineDiscount.reduce((total, item) => total + Number.parseFloat(item.total || 0), 0)
		);

		const baseDiscount = 0;

		// REMOVED TAX & SHIPPING
		const taxes = 0;
		const shipping = 0;

		const promoDiscount = roundCurrency(promotionResult?.summary?.promo_discount || 0);

		const totalBeforePromotion = roundCurrency(
			productTotalAfterLineDiscount
		);

		const total = roundCurrency(
			Math.max(0, totalBeforePromotion - promoDiscount)
		);

		return {
			products: productsWithPromotion,
			productTotal,
			lineDiscountTotal,
			productTotalAfterLineDiscount,
			taxes,
			baseDiscount,
			shipping,
			promoDiscount,
			totalBeforePromotion,
			total,
		};
	}, [appliedPromotion, buildCartProductsPayload, lineDiscountResolution]);
	const orderSummary = useMemo(() => buildOrderSummary(), [buildOrderSummary]);
	const buildOrderDetails = useCallback(
		({ includePromotion = false, promotionResult = appliedPromotion } = {}) => {
			const summary = includePromotion
				? buildOrderSummary(promotionResult)
				: buildOrderSummary(null);
			const promotion = promotionResult?.promotion;
			const promoDiscountAmount =
				includePromotion && promotion
					? summary.promoDiscount
					: 0;

			const details = {
				products: summary.products,
				taxes: "0.00",
				shipping: "0.00",
				discounts: roundCurrency(summary.lineDiscountTotal + promoDiscountAmount).toFixed(2),
				line_discount_total: summary.lineDiscountTotal.toFixed(2),
				subtotal_before_line_discounts: summary.productTotal.toFixed(2),
				subtotal_after_line_discounts: summary.productTotalAfterLineDiscount.toFixed(2),
				total: includePromotion
					? summary.total.toFixed(2)
					: summary.totalBeforePromotion.toFixed(2),
				currency: selectedSiteCurrency || "usd",
			};

			if (includePromotion && promotion) {
				details.promo_code = promotion.code;
				details.promotion = {
					id: promotion.id,
					code: promotion.code,
					discount_type: promotion.discount_type,
					discount_value: promotion.discount_value,
					discount_amount: summary.promoDiscount,
					lines: promotionResult.lines || [],
				};
			}

			return details;
		},
		[appliedPromotion, buildOrderSummary, selectedSiteCurrency]
	);
	const formatAddress = (parts) => {
		return parts
			.map((part) => part?.trim())
			.filter(Boolean)
			.join(", ");
	};

	useEffect(() => {
		//always set DT/DM (so dropdown always has options)
		const legalEntity = selectedSiteLegalEnitity || "AUSA";
		const deliveryTermsOptions = DT_BY_LE[legalEntity] || DT_BY_LE["AUSA"];
		const deliveryModeOptions = DM_BY_LE[legalEntity] || DM_BY_LE["AUSA"];

		const translatedDeliveryTermsOptions = deliveryTermsOptions.map((opt) => ({
			...opt,
			//supports both descriptionKey and description (EUUK uses description)
			description: t(opt.descriptionKey || opt.description || ""),
		}));

		setDTOptions(translatedDeliveryTermsOptions);
		setDMOptions(deliveryModeOptions);

		// keep this logic for delivery_terms defaulting
		setCheckoutDetails((prev) => {
			const currentDeliveryTerm = prev?.additional_details?.delivery_terms || "";
			const isCurrentValidTerm = translatedDeliveryTermsOptions.some(
				(opt) => opt.term === currentDeliveryTerm
			);
			if (isCurrentValidTerm) return prev;

			const matchedByDescription = translatedDeliveryTermsOptions.find(
				(opt) => opt.description === currentDeliveryTerm
			);

			return {
				...prev,
				additional_details: {
					...prev.additional_details,
					delivery_terms:
						matchedByDescription?.term || translatedDeliveryTermsOptions[0]?.term || "",
				},
			};
		});

		//only block customer fetch if cus_id not ready
		if (!selectedSite || !selectedSiteData?.cus_id) return;

		const fetchCustomerData = async () => {
			try {
				const customer_resp = await getCustomerByIdForCusSites(selectedSiteData.cus_id);
				// A functional setState updater runs later, during React's own render pass —
				// this try/catch only guards the synchronous call site, so a missing
				// customer_resp.data (failed/empty lookup) crashed the whole page when React
				// invoked the updater below and it read .address_name_cus off undefined.
				if (!customer_resp?.data) return;
				setSelectedCustomer(customer_resp.data);
				setCheckoutDetails((prev) => ({
					...prev,
					billing_address: {
						name: `${customer_resp.data.address_name_cus}`,
						street: formatAddress([
							customer_resp.data.street1_cus,
							customer_resp.data.street2_cus,
							customer_resp.data.street3_cus,
						]),
						city: `${customer_resp.data.city_cus}`,
						zip: `${customer_resp.data.zip_cus}`,
						country: `${customer_resp.data.country_cus}`,
						state: `${customer_resp.data.state_cus}`,
					},
					shipping_address: {
						name: `${selectedSiteData.address_name_ln} - ${selectedSiteData.customer_site_number}`,
						street: formatAddress([
							selectedSiteData.street1_ln,
							selectedSiteData.street2_ln,
							selectedSiteData.street3_ln,
						]),
						city: `${selectedSiteData.city_ln}`,
						zip: `${selectedSiteData.zip_ln}`,
						country: `${selectedSiteData.country_ln}`,
						state: `${selectedSiteData.state_ln}`,
					},
				}));
			} catch (error) {

			}
		};

		fetchCustomerData();
	}, [selectedSite, selectedSiteData, selectedSiteLegalEnitity, t]);
	const handleInputChange = (section, field, value) => {
		setCheckoutDetails((prev) => ({
			...prev,
			[section]: {
				...prev[section],
				[field]: value,
			},
		}));

		// Mark dirty if user typed while editing
		if (section === 'shipping_address' || section === 'shipping') setShippingDirty(true);
		if (section === 'billing_address' || section === 'billing') setBillingDirty(true);
	};

	const handleAccordionChange = (panel) => (event, isExpanded) => {
		setExpandedPanels((prev) => ({
			...prev,
			[panel]: isExpanded,
		}));
	};

	const handleCheckboxChange = (event) => {
		setTermsAccepted(event.target.checked);
	};

	useEffect(() => {
		if (!orderSchedulesEnabled && scheduleOpen) {
			setScheduleOpen(false);
		}
	}, [orderSchedulesEnabled, scheduleOpen]);

	const handleScheduleButton = async (event) => {
		// );
		// setSelectedOrderSchedule(transformCartProducts(cartProducts));
		setScheduleOpen(true);

	};


	const transformCartProducts = (products) => {
		const prods = products.map((item) => {
			const product = item.Product;
			const price =
				product[`price_${selectedSiteCurrency}`] ??
				product.product_sell_price ??
				0;
			const quantity = item.Quantity || 1;

			return {
				id: null,
				order_id: product.product_id,
				product_id: product.product_id,
				machine_id:
					item.machine_id ||
					item.MachineID ||
					product.machine_id,
				product_quantity: quantity,
				product_price: price.toString(),
				product_total: (Number(price) * Number(quantity)).toFixed(2),
				productsData: product,
			};
		});
		return {
			shipping_address: checkoutDetails.shipping_address,
			billing_address: checkoutDetails.billing_address,
			additional_details: checkoutDetails.additional_details,
			payment_details: checkoutDetails.payment_details,
			order_details: buildOrderDetails({ includePromotion: false }),
			selectedSite: selectedSiteData.site_id,
			site_id: selectedSiteData.site_id,
			site_number: selectedSite,
			customer_id: selectedSiteData?.cus_id,
			legal_entity: legalEntity,
			currency: selectedSiteCurrency || "usd",
			loggedin_user: user.user_id,
			loggedin_user_email: user.user_email,
			loggedin_user_name: user.user_first_name + " " + user.user_last_name,
			loggedin_user_phone: user.user_phone || "",
			products: prods,
		};
	};

	const hasShippingError = Object.keys(errors).some((key) =>
		key.startsWith("shipping_address.")
	);

	const hasBillingError = Object.keys(errors).some((key) =>
		key.startsWith("billing_address.")
	);



	const handleFileUpload = (event) => {
		const file = event.target.files[0];
		if (!file) return;

		const allowedTypes = [
			"application/pdf",
			"image/jpeg",
			"image/png",
			"application/msword",
			"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
		];
		const maxFileSize = 10 * 1024 * 1024; // 10MB

		if (!allowedTypes.includes(file.type)) {
			Swal.fire({
				icon: "error",
				title: t("ALERT_MESSAGES.INVALID_FILE_TYPE_TITLE"),
				text: t("ALERT_MESSAGES.INVALID_FILE_TYPE_TEXT"),
			});
			return;
		}

		if (file.size > maxFileSize) {
			Swal.fire({
				icon: "error",
				title: t("ALERT_MESSAGES.FILE_TOO_LARGE_TITLE"),
				text: t("ALERT_MESSAGES.FILE_TOO_LARGE_TEXT"),
			});
			return;
		}

		// Store full file object
		setUploadedFile(file);

		// Reset input for future uploads
		event.target.value = null;
	};

	const handleDeleteFile = () => {
		setUploadedFile(null);
	};



	useEffect(() => {
		const fetchProducts = async () => {
			setLoading(true);
			setError(null);

			const filteredCartItems = cartItems.filter(
				(item) => String(getCartSite(item)) === String(selectedSite)
			);

			if (filteredCartItems.length === 0) {
				setCartProducts([]);
				setLoading(false);
				setIsInitialized(true);
				return;
			}

			try {

				let products = [
					...new Set(
						filteredCartItems
							.filter(
								(item) =>
									(item.ProductID || item.product_id) &&
									String(getCartSite(item)) === String(selectedSite)
							)
							.map((item) => item.ProductID || item.product_id)
					),
				];
				let site_number = selectedSite;


				const response = await getProductsById(
					products,
					site_number,
					filteredCartItems.map((item) => ({
						product_id: item.ProductID || item.product_id,
						machine_id: item.machine_id || item.MachineID || item.machineId,
					}))
				);

				const productData = response?.data || [];

				const updatedCartItems = await Promise.all(
					filteredCartItems.map(async (item) => {
						const itemProductId = item.ProductID || item.product_id;
						const itemMachineId = item.machine_id || item.MachineID || item.machineId;
						const matchedProduct =
							productData.find(
								(product) =>
									Number(product.product_id) === Number(itemProductId) &&
									(
										!itemMachineId ||
										Number(product.machine_id) === Number(itemMachineId)
									)
							) ||
							productData.find(
								(product) => Number(product.product_id) === Number(itemProductId)
							);
						if (matchedProduct) {
							return {
								...item,
								Product: {
									...matchedProduct,
									machine_id:
										item.machine_id ||
										item.MachineID ||
										item.machineId ||
										matchedProduct.machine_id ||
										matchedProduct.machineId,
									machine_number:
										item.machine_number ||
										item.MachineNumber ||
										item.machineNumber ||
										item.machine_name ||
										matchedProduct.machine_number,
								},
							};
						}
						return null;
					})
				);

				setCartProducts(updatedCartItems.filter(item => item));
			} catch (err) {
				setError("Failed to fetch data: " + err.message);
			} finally {
				setLoading(false);
				setIsInitialized(true);
			}
		};

		if (cartItems.length > 0) {
			fetchProducts();
		} else {
			setCartProducts([]);
			setLoading(false);
			setIsInitialized(true);
		}
	}, [selectedSite, cartItems, refreshTick]);

	useEffect(() => {
		setAppliedPromotion(null);
		setLineDiscountResolution(null);
		setPromotionError("");
	}, [cartProducts, selectedSite, selectedSiteCurrency]);

	useEffect(() => {
		let active = true;
		const siteId = resolveCurrentSiteId();
		const products = buildCartProductsPayload();

		if (!products.length || !siteId) {
			setLineDiscountResolution(null);
			setLineDiscountLoading(false);
			return () => {
				active = false;
			};
		}

		const loadLineDiscounts = async () => {
			setLineDiscountLoading(true);
			try {
				const response = await resolveLineDiscounts({
					selectedSite: siteId,
					site_id: siteId,
					customer_site_id: siteId,
					customer_id: selectedSiteData?.cus_id,
					legal_entity: legalEntity,
					currency: selectedSiteCurrency || "usd",
					products,
					order_details: {
						products,
						currency: selectedSiteCurrency || "usd",
					},
				});
				if (!active) return;
				const resolution = response?.data || response;
				setLineDiscountResolution(resolution?.valid ? resolution : null);
			} catch (error) {
				if (active) setLineDiscountResolution(null);
			} finally {
				if (active) setLineDiscountLoading(false);
			}
		};

		loadLineDiscounts();
		return () => {
			active = false;
		};
	}, [buildCartProductsPayload, legalEntity, resolveCurrentSiteId, selectedSite, selectedSiteCurrency, selectedSiteData?.cus_id]);

	useEffect(() => {
		let active = true;
		const siteId = resolveCurrentSiteId();

		if (!siteId) {
			setPromotionAvailable(false);
			setPromotionCode("");
			setAppliedPromotion(null);
			setPromotionError("");
			return () => {
				active = false;
			};
		}

		const loadPromotionAvailability = async () => {
			try {
				const response = await getPromotionAvailability({
					site_id: siteId,
					customer_site_id: siteId,
					customer_id: selectedSiteData?.cus_id,
				});
				if (!active) return;
				const availability = response?.data || response || {};
				const enabled = Boolean(availability.enabled);
				setPromotionAvailable(enabled);
				if (!enabled) {
					setPromotionCode("");
					setAppliedPromotion(null);
					setPromotionError("");
				}
			} catch (error) {
				if (!active) return;
				setPromotionAvailable(false);
				setPromotionCode("");
				setAppliedPromotion(null);
				setPromotionError("");
			}
		};

		loadPromotionAvailability();
		return () => {
			active = false;
		};
	}, [resolveCurrentSiteId, selectedSiteData?.cus_id]);

	const validatePromotionCode = async (code) => {
		const orderDetails = buildOrderDetails({ includePromotion: false });
		const siteId = resolveCurrentSiteId();
		const response = await validatePromotion({
			code,
			selectedSite: siteId,
			customer_site_id: siteId,
			customer_id: selectedSiteData?.cus_id,
			user_id: user?.user_id,
			loggedin_user: user?.user_id,
			order_details: orderDetails,
			products: orderDetails.products,
			currency: selectedSiteCurrency || "usd",
		});
		const validation = response?.data || response;
		console.log("PROMO VALIDATION PAYLOAD", {
			code,
			selectedSite: siteId,
			customer_site_id: siteId,
			customer_id: selectedSiteData?.cus_id,
			user_id: user?.user_id,
			loggedin_user: user?.user_id,
			order_details: orderDetails,
			products: orderDetails.products,
			currency: selectedSiteCurrency || "usd",
		});
		return validation;
	};

	const applyPromotionValidation = (validation, code) => {
		if (validation?.valid) {
			const summary = buildOrderSummary(validation);

			const originalPrice = roundCurrency(summary.totalBeforePromotion || 0);
			const discountedPrice = roundCurrency(summary.total || 0);
			const discountAmount = roundCurrency(summary.promoDiscount || 0);
			const discountPercentage =
				originalPrice > 0
					? roundCurrency((discountAmount / originalPrice) * 100)
					: 0;

			setAppliedPromotion(validation);
			setPromotionCode(validation.promotion?.code || code.toUpperCase());

			trackEvent(
				"promo_applied",
				buildPromotionAnalyticsPayload(validation, code, {
					original_price: originalPrice,
					discounted_price: discountedPrice,
					discount_amount: discountAmount,
					discount_percentage: discountPercentage,
					price_before_discount: originalPrice,
					price_after_discount: discountedPrice,
				})
			);

			return true;
		}

		setAppliedPromotion(null);
		setPromotionError(validation?.message || "Promotion code is not valid");

		trackEvent("promo_failed", buildPromotionAnalyticsPayload(validation, code, {
			reason: validation?.message || validation?.reason || "Promotion code is not valid",
		}));

		return false;
	};

	const handleApplyPromotion = async () => {
		const code = promotionCode.trim();
		if (!promotionAvailable) {
			setAppliedPromotion(null);
			setPromotionError("Promotion codes are not available for this site");
			return null;
		}
		if (!code) {
			setAppliedPromotion(null);
			setPromotionError("Promotion code is required");
			return null;
		}

		setPromotionLoading(true);
		setPromotionError("");
		try {
			const validation = await validatePromotionCode(code);
			applyPromotionValidation(validation, code);
			return validation;
		} catch (error) {
			setAppliedPromotion(null);
			setPromotionError("Promotion code could not be validated");
			return null;
		} finally {
			setPromotionLoading(false);
		}
	};

	const handleRemovePromotion = () => {
		setAppliedPromotion(null);
		setPromotionCode("");
		setPromotionError("");
	};

	const validateAddress = (address, fieldPrefix) => {
		const newErrors = {};

		// This validation logic to find new errors remains the same
		if (!address.name?.trim()) newErrors[`${fieldPrefix}.name`] = t('UI_TEXT.NAME_REQUIRED');
		if (!address.street?.trim()) newErrors[`${fieldPrefix}.street`] = t('UI_TEXT.STREET_REQUIRED');
		if (!address.city?.trim()) newErrors[`${fieldPrefix}.city`] = t('UI_TEXT.CITY_REQUIRED');
		if (!address.zip?.trim()) newErrors[`${fieldPrefix}.zip`] = t('UI_TEXT.ZIPCODE_REQUIRED');
		if (!address.country?.trim()) newErrors[`${fieldPrefix}.country`] = t('UI_TEXT.COUNTRY_REQUIRED');
		if (!address.state?.trim()) newErrors[`${fieldPrefix}.state`] = t('UI_TEXT.STATE_REQUIRED');

		// Update state with errors
		setErrors((prevErrors) => {
			// 1. Create a new object that includes only the errors NOT related to the current section.
			const otherErrors = Object.fromEntries(
				Object.entries(prevErrors).filter(([key]) => !key.startsWith(fieldPrefix))
			);

			// 2. Return a new state object that combines the other errors with any new errors found for this section.
			return { ...otherErrors, ...newErrors };
		});

		// Return both the validation result and the errors found
		return {
			isValid: Object.keys(newErrors).length === 0,
			errors: newErrors
		};
	};

	const validateAdditionalOrderDetails = () => {
		const { delivery_terms, ship_complete, mode_of_delivery } = checkoutDetails.additional_details;
		const newErrors = {};
		const hideCarrierFields = ["PPD-ADD", "DDP", "DAP"].includes(delivery_terms);

		if (!delivery_terms) newErrors["additional_details.delivery_terms"] = t("UI_TEXT.DELIVERY_TERMS_REQUIRED");
		if (!ship_complete) newErrors["additional_details.ship_complete"] = t("UI_TEXT.SHIP_COMPLETE_REQUIRED");
		if (!hideCarrierFields && !mode_of_delivery) newErrors["additional_details.mode_of_delivery"] = t("UI_TEXT.PREFERRED_CARRIER_REQUIRED");

		// Return both the validation result and the errors found
		return {
			isValid: Object.keys(newErrors).length === 0,
			errors: newErrors
		};
	};

	const validatePaymentDetails = () => {
		const { payment_mode, payment_details } = checkoutDetails.payment_details;
		const newErrors = {};
		// const isFileUploaded = uploadedFile.length > 0;

		// Check if payment_details.po_number, after trimming, is empty
		if (payment_mode === "PO" && !payment_details.po_number?.trim()) {
			newErrors["payment_details.payment_details.po_number"] = t('FORMS.PO_NUMBER_REQUIRED_FOR_PO_PAYMENT_MODE');
		}

		// Return both the validation result and the errors found
		return {
			isValid: Object.keys(newErrors).length === 0,
			errors: newErrors
		};
	};

	const handlePaymentModeChange = (event) => {
		const value = event.target.value;
		setCheckoutDetails((prev) => ({
			...prev,
			payment_details: {
				...prev.payment_details,
				payment_mode: value,
				payment_details: {
					...prev.payment_details.payment_details,
					po_number: value === "PO" ? prev.payment_details.payment_details.po_number : "",
				},
			},
		}));
	};

	const updateNestedField = (obj, path, value) => {
		if (path.length === 0) return value;
		const [key, ...rest] = path;

		return {
			...obj,
			[key]: rest.length > 0
				? updateNestedField(obj?.[key] ?? {}, rest, value)
				: value,
		};
	};



	const handleFieldChange = (section, field, value) => {
		setCheckoutDetails((prevDetails) => updateNestedField(prevDetails, [section, ...field.split(".")], value));
		if (section.includes('shipping')) setShippingDirty(true);
		if (section.includes('billing')) setBillingDirty(true);
	};

	const handleSelectSavedAddress = (section, addrId) => {
		const source = section === 'shipping' ? shippingAddresses : billingAddresses;
		const picked = source.find(a => a.id === addrId);
		if (!picked) return;
		const toUpdate = {
			name: picked.address_name,
			street: [picked.street1, picked.street2, picked.street3].filter(Boolean).join(', '),
			city: picked.city || '',
			state: picked.state || '',
			zip: picked.zip || '',
			country: picked.country || '',
		};
		setCheckoutDetails(prev => ({
			...prev,
			[section === 'shipping' ? 'shipping_address' : 'billing_address']: toUpdate,
		}));
		if (section === 'shipping') { setSelectedShippingId(addrId); setShippingDirty(false); }
		else { setSelectedBillingId(addrId); setBillingDirty(false); }
	};

	const splitStreet = (street) => {
		if (!street) return { street1: '', street2: '', street3: '' };
		const parts = street.split(',').map(s => s.trim()).filter(Boolean);
		return {
			street1: parts[0] || '',
			street2: parts[1] || '',
			street3: parts[2] || '',
		};
	};

	const handleSaveAddress = async (section, asNew = false, nameOverride) => {
		const addr = section === 'shipping' ? checkoutDetails.shipping_address : checkoutDetails.billing_address;
		const { street1, street2, street3 } = splitStreet(addr.street);
		const payload = {
			address_name: nameOverride || addr.name,
			address_type: section === 'shipping' ? 'Shipping' : 'Billing',
			site_id: selectedSiteData?.site_id,
			street1, street2, street3,
			city: addr.city,
			state: addr.state,
			zip: addr.zip,
			country: addr.country,
		};
		try {
			if (!asNew) {
				const id = section === 'shipping' ? selectedShippingId : selectedBillingId;
				if (id) {
					await updateSiteAddress(id, payload);
				} else {
					await createSiteAddress(payload);
				}
			} else {
				await createSiteAddress(payload);
			}
			// refresh lists
			if (section === 'shipping') {
				const list = await fetchSiteAddresses('Shipping');
				setShippingAddresses(list);
				setShippingDirty(false);
			} else {
				const list = await fetchSiteAddresses('Billing');
				setBillingAddresses(list);
				setBillingDirty(false);
			}
			showSnack(t('UI_TEXT.ADDRESS_SAVED'), 'success');
		} catch (e) {
			showSnack(t('ERRORS.FAILED_TO_SAVE_ADDRESS'), 'error');
		}
	};

	const handleOrderFailure = (orderData) => {
		navigate("/order-failure", { state: { orderData }, replace: true });
	};

	const handleCheckout = async () => {
		setButtonLoading(true);
		const selectedSiteDetails = siteData.filter((site) => site.customer_site_number === selectedSite);

		let base64File = "";
		let fileName = "";
		if (uploadedFile) {
			try {
				const file = uploadedFile;
				fileName = file.name;
				const reader = new FileReader();
				base64File = await new Promise((resolve, reject) => {
					reader.onload = () => resolve(reader.result.split(",")[1]);
					reader.onerror = reject;
					reader.readAsDataURL(file);
				});
			} catch (error) {
				console.error("Error converting file to base64:", error);
				setButtonLoading(false);
				Swal.fire({
					icon: "error",
					title: t('ALERT_MESSAGES.ERROR'),
					text: t('UI_TEXT.ERROR_PROCESSING_UPLOADED_FILE_PLEASE_TRY_AGAIN'),
				});
				return;
			}
		}

		if (cartProducts.some((i) => !i.Product.purchasable)) {
			setButtonLoading(false);
			Swal.fire({
				icon: "error",
				title: t('ALERT_MESSAGES.ERROR'),
				text: t('ALERT_MESSAGES.CANNOT_COMPLETE_CHECKOUT'),
			});
			return;
		}

		const isShippingValid = validateAddress(checkoutDetails.shipping_address, "shipping_address");
		const isBillingValid = validateAddress(checkoutDetails.billing_address, "billing_address");
		const areAdditionalDetailsValid = validateAdditionalOrderDetails();
		const arePaymentDetailsValid = validatePaymentDetails();

		// Combine all errors before updating state
		const allErrors = {
			...isShippingValid.errors,
			...isBillingValid.errors,
			...areAdditionalDetailsValid.errors,
			...arePaymentDetailsValid.errors
		};

		if (
			!isShippingValid.isValid ||
			!isBillingValid.isValid ||
			!areAdditionalDetailsValid.isValid ||
			!arePaymentDetailsValid.isValid ||
			!termsAccepted
		) {
			setButtonLoading(false);

			// Update errors state with all collected errors
			setErrors(allErrors);

			// Collect all missing fields from the collected errors
			const missingFields = [];

			Object.keys(allErrors).forEach((key) => {
				if (key.startsWith("shipping_address.")) {
					const fieldName = key.split(".")[1]?.replace("_", " ");
					missingFields.push(`<b>${t("UI_TEXT.SHIPPING_ADDRESS")}</b> → ${fieldName}`);
				} else if (key.startsWith("billing_address.")) {
					const fieldName = key.split(".")[1]?.replace("_", " ");
					missingFields.push(`<b>${t("UI_TEXT.BILLING_ADDRESS")}</b> → ${fieldName}`);
				} else if (key.startsWith("additional_details.")) {
					const fieldName = key.split(".")[1]?.replace("_", " ");
					missingFields.push(`<b>${t("UI_TEXT.ADDITIONAL_ORDER_DETAILS")}</b> → ${fieldName}`);
				} else if (key.startsWith("payment_details.")) {
					const fieldName = key.split(".").slice(-1)[0]?.replace("_", " ");
					missingFields.push(`<b>${t("UI_TEXT.PAYMENT_DETAILS")}</b> → ${fieldName}`);
				}
			});

			if (!termsAccepted) {
				missingFields.push(`<b>${t('UI_TEXT.TERMS_CONDITIONS')}</b> → ${t('UI_TEXT.NOT_ACCEPTED')}`);
			}

			const formattedList = missingFields.length
				? `<ul style="list-style-type:none; padding:0; margin:10px 0; font-size:12px; text-align:center;">
						${missingFields.map((f) => `<li>${f}</li>`).join("")}
					</ul>`
				: `<p style="font-size:12px; text-align:center;">${t("UI_TEXT.FILL_REQUIRED_FIELDS_BEFORE_PROCEEDING")}</p>`;

			Swal.fire({
				icon: "error",
				title: t('UI_TEXT.MISSING_REQUIRED_FIELDS'),
				html: `
					<div style="font-size:12px; text-align:center;">
						${t('UI_TEXT.SOME_REQUIRED_FIELDS_ARE_MISSING_OR_INCOMPLETE')}
					</div>
					${formattedList}
					`,
				confirmButtonText: t('UI_TEXT.REVIEW_AND_FIX'),
				confirmButtonColor: "#1976d2",
			});

			return;
		}
		let promotionForOrder = appliedPromotion;
		const pendingPromotionCode = promotionCode.trim();
		if (pendingPromotionCode && !promotionAvailable) {
			setButtonLoading(false);
			setAppliedPromotion(null);
			setPromotionError("Promotion codes are not available for this site");
			Swal.fire({
				icon: "error",
				title: "Promotion code is not available",
				text: "This site is not enabled for promotion codes.",
				confirmButtonColor: "#1976d2",
			});
			return;
		}
		if (pendingPromotionCode && !promotionForOrder) {
			setPromotionLoading(true);
			setPromotionError("");
			try {
				const validation = await validatePromotionCode(pendingPromotionCode);
				if (!applyPromotionValidation(validation, pendingPromotionCode)) {
					setButtonLoading(false);
					Swal.fire({
						icon: "error",
						title: "Promotion code is not valid",
						text: validation?.message || "Please apply a valid promotion code before placing the order.",
						confirmButtonColor: "#1976d2",
					});
					return;
				}
				promotionForOrder = validation;
			} catch (error) {
				setButtonLoading(false);
				setAppliedPromotion(null);
				setPromotionError("Promotion code could not be validated");
				Swal.fire({
					icon: "error",
					title: "Promotion code could not be validated",
					text: "Please try again before placing the order.",
					confirmButtonColor: "#1976d2",
				});
				return;
			} finally {
				setPromotionLoading(false);
			}
		}

		const quantityViolations = getOrderQuantityViolations();
		if (quantityViolations.length > 0) {
			setButtonLoading(false);
			Swal.fire({
				icon: "error",
				title: t("UI_TEXT.INVALID_QUANTITY", { defaultValue: "Invalid quantity" }),
				html: `<ul style="text-align:left;">${quantityViolations.map((message) => `<li>${message}</li>`).join("")}</ul>`,
				confirmButtonColor: "#1976d2",
			});
			return;
		}

		const orderDetails = buildOrderDetails({
			includePromotion: Boolean(promotionForOrder),
			promotionResult: promotionForOrder,
		});
		const currentSiteId = selectedSiteDetails[0]?.site_id || resolveCurrentSiteId();

		const newCheckoutDetails = {
			shipping_address: checkoutDetails.shipping_address,
			billing_address: checkoutDetails.billing_address,
			additional_details: checkoutDetails.additional_details,
			payment_details: {
				payment_mode: checkoutDetails.payment_details.payment_mode,
				payment_details: {
					po_number: checkoutDetails.payment_details.payment_details.po_number,
					po_file: base64File,
					po_filename: fileName,
				},
			},
			order_details: orderDetails,
			promo_code: promotionForOrder?.promotion?.code,
			selectedSite: currentSiteId,
			site_id: currentSiteId,
			site_number: selectedSite,
			customer_id: selectedSiteData?.cus_id,
			legal_entity: legalEntity,
			currency: selectedSiteCurrency || "usd",
			loggedin_user: user.user_id,
			loggedin_user_email: user.user_email,
			loggedin_user_name: user.user_first_name + " " + user.user_last_name,
			loggedin_user_phone: user.user_phone || "",
		};

		setCheckoutDetails(newCheckoutDetails);

		try {
			// Send the API request to place the order
			const response = await createOrder(newCheckoutDetails);

			// Handle success
			if (response.data && response.status) {
				if (promotionForOrder?.promotion?.code) {
					trackEvent("order_placed_with_promo", buildPromotionAnalyticsPayload(promotionForOrder, promotionForOrder.promotion.code, {
						order_number: response.data.order_number || response.data.sales_order_number || "",
						order_key: response.data.order_key || "",
					}));
				}
				clearCart();
				setButtonLoading(false);
				setButtonSuccess(true);
				setTimeout(() => {
					setButtonSuccess(false);
					navigate(`/order-received/${response.data.order_key}`, { replace: true });
				}, 1000);
			} else {
				setButtonLoading(false);
				console.error("Failed to place order: ", response.data.message);
				handleOrderFailure(newCheckoutDetails)
				setError(response.data.message || t('ALERT_MESSAGES.ERROR_OCCURED_WHILE_PLACING'));
			}
		} catch (error) {
			setButtonLoading(false);
			console.error("Error while placing the order", error);
			handleOrderFailure(newCheckoutDetails)
			setError(t('ALERT_MESSAGES.ERROR_OCCURED_PLACING_ORDER'));
		}
	};

	const toggleEdit = (section) => {
		if (!canEditCheckoutAddresses) return;
		setIsEditing((prev) => ({ ...prev, [section]: !prev[section] }));
		// On enabling edit, fetch saved addresses
		(async () => {
			if (!isEditing[section]) {
				if (section === 'shipping') {
					const list = await fetchSiteAddresses('Shipping');
					setShippingAddresses(list);
					const def = list.find(a => a.is_default);
					if (def) {
						setSelectedShippingId(def.id);
						handleSelectSavedAddress('shipping', def.id);
					}
				} else {
					const list = await fetchSiteAddresses('Billing');
					setBillingAddresses(list);
					const def = list.find(a => a.is_default);
					if (def) {
						setSelectedBillingId(def.id);
						handleSelectSavedAddress('billing', def.id);
					}
				}
			}
		})();
	};

	useEffect(() => {
		if (canEditCheckoutAddresses) return;
		setIsEditing({ shipping: false, billing: false });
		setRenameOpen(false);
	}, [canEditCheckoutAddresses]);

	if (loading) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
				<CircularProgress />
			</Box>
		);
	}

	if (error && !loading && !orderFailure) {
		return (
			<Alert severity="error" className="error-alert">
				{error}
			</Alert>
		);
	}

	if (orderFailure && error) {
		return (
			<>
				{orderFailureData ? (<>
					<OrderFailure orderData={orderFailureData} />
				</>) : (
					<Alert severity="error" className="error-alert">
						{error}
					</Alert>
				)}
			</>
		)
	}

	if (!hasPermission("order_management.create_order")) {
		return <NotAuthorized />
	}

	return (
		<Box padding={2} pt={"5px"} width="100%">
			{/* Rename modal for save-as-new */}
			<ModalWrapper
				open={renameOpen}
				setOpen={setRenameOpen}
				title={t('UI_TEXT.SAVE_AS_NEW_ADDRESS')}
				content={(
					<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, p: 1 }}>
						<TextField size="small" label={t('UI_TEXT.ADDRESS_NAME')} value={renameValue} onChange={(e) => setRenameValue(e.target.value)} />
					</Box>
				)}
				actions={(
					<>
						<Button variant="outlined" onClick={() => setRenameOpen(false)}>{t('BUTTON.CANCEL')}</Button>
						<Button variant="contained" onClick={() => { if (renameValue?.trim()) { handleSaveAddress(renameSection, true, renameValue.trim()); setRenameOpen(false); } }}>{t('BUTTON.SAVE')}</Button>
					</>
				)}
			/>

			<PageTitle title={t('BUTTON.CHECKOUT')}></PageTitle>
			<Box
				display="flex"
				justifyContent="space-between"
				gap="20px"
				alignItems="flex-start"
				flexDirection={isMobile ? "column" : "row"}
				margin="0 auto"
				marginTop={3}
				sx={{ width: isMobile ? "100%" : "85%" }}>
				{/* Left Section */}
				<Box width={isMobile ? "100%" : "65%"} padding="5px" marginBottom={2} sx={{ boxShadow: "0 0 6px 1px rgba(0,0,0,0.1)", borderRadius: '10px' }}>
					<Accordion sx={{ boxShadow: "none" }} onChange={handleAccordionChange("panel1")} defaultExpanded data-tour="checkout-shipping-billing">
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<Typography
								variant="h6"
								sx={{ fontWeight: "bold" }}
								color={expandedPanels.panel1 ? "primary" : ""}>
								{t('UI_TEXT.SHIPPING_BILLING_ADDRESS')}
							</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Box
								display="flex"
								flexDirection={isMobile ? "column" : "row"}
								justifyContent="space-between"
								gap="10px">
								{/* Shipping Address Card */}
								<Box
									sx={{
										width: isMobile ? "100%" : "48%",
										borderRadius: "10px",
										...(hasShippingError
											? {
												borderColor: "error.main",
												borderWidth: 1,
												borderStyle: "solid",
											}
											: {
												borderColor: "#e5e7eb",
												borderWidth: 1,
												borderStyle: "solid",
											}),
										p: 2, // same padding as CardContent
									}}
								>
									<Box display="flex" justifyContent="space-between" alignItems="center">
										<Typography variant="h6" sx={{ fontWeight: "bold" }}>
											{t('UI_TEXT.SHIPPING_ADDRESS')}
										</Typography>
										{canEditCheckoutAddresses && (
											<IconButton
												onClick={() => toggleEdit("shipping")}
												color={isEditing.shipping ? "primary" : ""}>
												{isEditing.shipping ?
													<Tooltip title={t("UI_TEXT.TOOLTIP_SAVE_ADDRESS")} arrow placement="top">
														<Check />
													</Tooltip>
													:
													<Tooltip title={t("UI_TEXT.TOOLTIP_EDIT_ADDRESS")} arrow placement="top">
														<EditIcon />
													</Tooltip>
												}
											</IconButton>
										)}
									</Box>
									{canEditCheckoutAddresses && isEditing.shipping ? (
										<Box mt={2}>

											<Autocomplete
												fullWidth
												size="small"
												options={shippingAddresses}
												getOptionLabel={(option) => option.address_name || ''}
												value={shippingAddresses.find((addr) => addr.id === selectedShippingId) || null}
												onChange={(event, newValue) => handleSelectSavedAddress('shipping', newValue ? newValue.id : '')}
												renderInput={(params) => (
													<TextField {...params} label={t('LABELS.SELECT_SAVED_ADDRESS')} variant="outlined" />
												)}
												renderOption={(props, option) => (
													<li {...props} key={option.id}>
														<Box>
															<Typography variant="body1">{option.address_name}</Typography>
															<Typography
																variant="body2"
																color="text.secondary"
																fontStyle="italic"
																fontSize="11px"
															>
																<b>{t('LABELS.ADDRESS')}: </b>{option.address_full}
															</Typography>
														</Box>
													</li>
												)}
											/>
											<Divider sx={{ my: 2 }} />
											<TextField
												required
												label={t('LABELS.NAME')}
												size="small"
												fullWidth
												value={checkoutDetails.shipping_address.name}
												error={!!errors["shipping_address.name"]}
												onChange={(e) =>
													handleInputChange("shipping_address", "name", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.shipping_address, "shipping_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.STREET')}
												required
												size="small"
												fullWidth
												value={checkoutDetails.shipping_address.street}
												error={!!errors["shipping_address.street"]}
												onChange={(e) =>
													handleInputChange("shipping_address", "street", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.shipping_address, "shipping_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.CITY')}
												size="small"
												fullWidth
												required
												value={checkoutDetails.shipping_address.city}
												error={!!errors["shipping_address.city"]}
												onChange={(e) =>
													handleInputChange("shipping_address", "city", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.shipping_address, "shipping_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.STATE')}
												size="small"
												fullWidth
												required
												value={checkoutDetails.shipping_address.state}
												error={!!errors["shipping_address.state"]}
												onChange={(e) =>
													handleInputChange("shipping_address", "state", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.shipping_address, "shipping_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.ZIP')}
												size="small"
												required
												fullWidth
												value={checkoutDetails.shipping_address.zip}
												error={!!errors["shipping_address.zip"]}
												onChange={(e) =>
													handleInputChange("shipping_address", "zip", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.shipping_address, "shipping_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.COUNTRY')}
												size="small"
												required
												fullWidth
												value={checkoutDetails.shipping_address.country}
												error={!!errors["shipping_address.country"]}
												onChange={(e) =>
													handleInputChange("shipping_address", "country", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.shipping_address, "shipping_address");
												}}
												sx={{ mb: 2 }}
											/>
											<Box display="flex" gap={1} justifyContent="flex-end" mt={1}>
												{shippingDirty && (
													(() => {
														const selected = shippingAddresses.find(a => a.id === selectedShippingId);
														const isDefault = !!selected?.is_default;
														return (
															<>
																{!isDefault && (
																	<Button size="small" variant="outlined" onClick={() => handleSaveAddress('shipping', false)}>{t('BUTTON.SAVE_ADDRESS')}</Button>
																)}
																<Button size="small" variant="contained" onClick={() => { setRenameSection('shipping'); setRenameValue(checkoutDetails.shipping_address.name || ''); setRenameOpen(true); }}>
																	{t('UI_TEXT.SAVE_AS_NEW_ADDRESS')}
																</Button>
															</>
														);
													})()
												)}
											</Box>
										</Box>
									) : (
										<Box>
											<Typography
												variant="body1"
												color={errors["shipping_address.name"] ? "error" : "inherit"}
											>
												{checkoutDetails.shipping_address.name?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["shipping_address.street"] ? "error" : "inherit"}
											>
												{checkoutDetails.shipping_address.street?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["shipping_address.city"] ? "error" : "inherit"}
											>
												{checkoutDetails.shipping_address.city?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["shipping_address.state"] ? "error" : "inherit"}
											>
												{checkoutDetails.shipping_address.state?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["shipping_address.zip"] ? "error" : "inherit"}
											>
												{checkoutDetails.shipping_address.zip?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["shipping_address.country"] ? "error" : "inherit"}
											>
												{checkoutDetails.shipping_address.country?.trim() || "—"}
											</Typography>
										</Box>
									)}

								</Box>

								{/* Billing Address Card */}
								<Box
									sx={{
										width: isMobile ? "100%" : "48%",
										borderRadius: "10px",
										...(hasBillingError
											? {
												borderColor: "error.main",
												borderWidth: 1,
												borderStyle: "solid",
											}
											: {
												borderColor: "#e5e7eb",
												borderWidth: 1,
												borderStyle: "solid",
											}),
										p: 2, // same padding as CardContent
									}}
								>
									<Box display="flex" justifyContent="space-between" alignItems="center">
										<Typography variant="h6" sx={{ fontWeight: "bold" }}>
											{t('UI_TEXT.BILLING_ADDRESS')}
										</Typography>
										{canEditCheckoutAddresses && (
											<IconButton
												onClick={() => toggleEdit("billing")}
												color={isEditing.billing ? "primary" : ""}>
												{isEditing.billing ?
													<Tooltip title={t("UI_TEXT.TOOLTIP_SAVE_ADDRESS")} arrow placement="top">
														<Check />
													</Tooltip>
													:
													<Tooltip title={t("UI_TEXT.TOOLTIP_EDIT_ADDRESS")} arrow placement="top">
														<EditIcon />
													</Tooltip>
												}
											</IconButton>
										)}
									</Box>
									{canEditCheckoutAddresses && isEditing.billing ? (
										<Box mt={2}>
											<Autocomplete
												fullWidth
												size="small"
												options={billingAddresses}
												getOptionLabel={(option) => option.address_name || ''}
												value={billingAddresses.find((addr) => addr.id === selectedBillingId) || null}
												onChange={(event, newValue) => handleSelectSavedAddress('billing', newValue ? newValue.id : '')}
												renderInput={(params) => (
													<TextField {...params} label={t('LABELS.SELECT_SAVED_ADDRESS')} variant="outlined" />
												)}
												renderOption={(props, option) => (
													<li {...props} key={option.id}>
														<Box>
															<Typography variant="body1">{option.address_name}</Typography>
															<Typography
																variant="body2"
																color="text.secondary"
																fontStyle="italic"
																fontSize="11px"
															>
																<b>{t('LABELS.ADDRESS')}: </b>{option.address_full}
															</Typography>
														</Box>
													</li>
												)}
											/>

											<Divider sx={{ my: 2 }} />
											<TextField
												label={t('LABELS.NAME')}
												size="small"
												required
												fullWidth
												value={checkoutDetails.billing_address.name}
												error={!!errors["billing_address.name"]}
												onChange={(e) =>
													handleInputChange("billing_address", "name", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.billing_address, "billing_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.STREET')}
												size="small"
												fullWidth
												required
												value={checkoutDetails.billing_address.street}
												error={!!errors["billing_address.street"]}
												onChange={(e) =>
													handleInputChange("billing_address", "street", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.billing_address, "billing_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.CITY')}
												size="small"
												fullWidth
												required
												value={checkoutDetails.billing_address.city}
												error={!!errors["billing_address.city"]}
												onChange={(e) =>
													handleInputChange("billing_address", "city", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.billing_address, "billing_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.STATE')}
												size="small"
												fullWidth
												required
												value={checkoutDetails.billing_address.state}
												error={!!errors["billing_address.state"]}
												onChange={(e) =>
													handleInputChange("billing_address", "state", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.billing_address, "billing_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.ZIP')}
												size="small"
												fullWidth
												required
												value={checkoutDetails.billing_address.zip}
												error={!!errors["billing_address.zip"]}
												onChange={(e) =>
													handleInputChange("billing_address", "zip", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.billing_address, "billing_address");
												}}
												sx={{ mb: 2 }}
											/>
											<TextField
												label={t('LABELS.COUNTRY')}
												size="small"
												fullWidth
												required
												value={checkoutDetails.billing_address.country}
												error={!!errors["billing_address.country"]}
												onChange={(e) =>
													handleInputChange("billing_address", "country", e.target.value)
												}
												onBlur={() => {
													validateAddress(checkoutDetails.billing_address, "billing_address");
												}}
												sx={{ mb: 2 }}
											/>
											<Box display="flex" gap={1} justifyContent="flex-end" mt={1}>
												{billingDirty && (
													(() => {
														const selected = billingAddresses.find(a => a.id === selectedBillingId);
														const isDefault = !!selected?.is_default;
														return (
															<>
																{!isDefault && (
																	<Button size="small" variant="outlined" onClick={() => handleSaveAddress('billing', false)}>{t('BUTTON.SAVE_ADDRESS')}</Button>
																)}
																<Button size="small" variant="contained" onClick={() => { setRenameSection('billing'); setRenameValue(checkoutDetails.billing_address.name || ''); setRenameOpen(true); }}>
																	{t('UI_TEXT.SAVE_AS_NEW_ADDRESS')}
																</Button>
															</>
														);
													})()
												)}
											</Box>
										</Box>
									) : (
										<Box>
											<Typography
												variant="body1"
												color={errors["billing_address.name"] ? "error" : "inherit"}
											>
												{checkoutDetails.billing_address.name?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["billing_address.street"] ? "error" : "inherit"}
											>
												{checkoutDetails.billing_address.street?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["billing_address.city"] ? "error" : "inherit"}
											>
												{checkoutDetails.billing_address.city?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["billing_address.state"] ? "error" : "inherit"}
											>
												{checkoutDetails.billing_address.state?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["billing_address.zip"] ? "error" : "inherit"}
											>
												{checkoutDetails.billing_address.zip?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["billing_address.country"] ? "error" : "inherit"}
											>
												{checkoutDetails.billing_address.country?.trim() || "—"}
											</Typography>
										</Box>
									)}

								</Box>
							</Box>
						</AccordionDetails>
					</Accordion>

					<Accordion sx={{ boxShadow: "none" }} onChange={handleAccordionChange("panel2")} defaultExpanded data-tour="checkout-additional-details">
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<Typography
								variant="h6"
								sx={{ fontWeight: "bold" }}
								color={expandedPanels.panel2 ? "primary" : ""}>
								{t('UI_TEXT.ADDITIONAL_ORDER_DETAILS')}
							</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
								<Box sx={{ display: "flex", gap: 2 }}>
									<FormControl fullWidth required>
										<InputLabel>{t('UI_TEXT.DELIVERY_TERMS')}</InputLabel>
										<Select
											size="small"
											value={checkoutDetails.additional_details.delivery_terms}
											error={!!errors["additional_details.delivery_terms"]}
											label={t('UI_TEXT.DELIVERY_TERMS')}
											renderValue={(selected) =>
												dTOptions.find((opt) => opt.term === selected)?.description || selected
											}
											onChange={(e) =>
												handleFieldChange("additional_details", "delivery_terms", e.target.value)
											}
										>
											{dTOptions.map((opt) => (
												<MenuItem key={opt.term} value={opt.term} sx={{ alignItems: "flex-start" }}>
													<Box>
														<Typography variant="body1">{opt.description}</Typography>
														{opt.helperText && (
															<Typography variant="body2" color="text.secondary">
																({opt.helperText})
															</Typography>
														)}
													</Box>
												</MenuItem>
											))}
										</Select>
									</FormControl>

									<FormControl fullWidth required>
										<InputLabel>{t('UI_TEXT.SHIP_COMPLETE')}</InputLabel>
										<Select
											size="small"
											value={checkoutDetails.additional_details.ship_complete}
											error={!!errors["additional_details.ship_complete"]}
											label={t('UI_TEXT.SHIP_COMPLETE')}
											onChange={(e) =>
												handleFieldChange("additional_details", "ship_complete", e.target.value)
											}>
											<MenuItem value="true">{t('MENU_ITEMS.YES')}</MenuItem>
											<MenuItem value="false">{t('MENU_ITEMS.NO')}</MenuItem>
										</Select>
									</FormControl>
								</Box>

								{!shouldHideCarrierFields && (
									<Box sx={{ display: "flex", gap: 2 }}>
										<FormControl fullWidth required>
											<InputLabel>{t("LABELS.PREFERRED_CARRIER")}</InputLabel>
											<Select
												size="small"
												value={checkoutDetails.additional_details.mode_of_delivery}
												error={!!errors["additional_details.mode_of_delivery"]}
												label={t("LABELS.PREFERRED_CARRIER")}
												onChange={(e) =>
													handleFieldChange("additional_details", "mode_of_delivery", e.target.value)
												}
											>
												{dMOptions.map((opt) => (
													<MenuItem key={opt.code} value={opt.code}>
														{opt.description}
													</MenuItem>
												))}
											</Select>
										</FormControl>

										<TextField
											fullWidth
											size="small"
											label={t("LABELS.YOUR_CARRIER_NUMBER")}
											value={checkoutDetails.additional_details.freight_number}
											onChange={(e) =>
												handleFieldChange("additional_details", "freight_number", e.target.value)
											}
											placeholder={t("PLACEHOLDER.ENTER_CARRIER_NUMBER")}
										/>
									</Box>
								)}

								<TextField
									fullWidth
									size="small"
									label={t('UI_TEXT.ORDER_NOTES')}
									multiline
									rows={4}
									value={checkoutDetails.additional_details.order_notes}
									onChange={(e) =>
										handleFieldChange("additional_details", "order_notes", e.target.value)
									}
									placeholder={t('PLACEHOLDER.ENTER_ORDER_NOTES')}
								/>
							</Box>
						</AccordionDetails>
					</Accordion>

					<Accordion sx={{ boxShadow: "none" }} onChange={handleAccordionChange("panel3")} defaultExpanded data-tour="checkout-payment-details">
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<Typography
								variant="h6"
								sx={{ fontWeight: "bold" }}
								color={expandedPanels.panel3 ? "primary" : ""}>
								{t('UI_TEXT.PAYMENT_DETAILS')}
							</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									gap: 2,
								}}>
								{/* First row */}
								<Box sx={{ display: "flex", gap: 2 }}>
									<FormControl fullWidth required>
										<InputLabel>{t('LABELS.PAYMENT_METHOD')}</InputLabel>
										<Select
											size="small"
											value={checkoutDetails.payment_details.payment_mode}
											onChange={handlePaymentModeChange}
											label={t('LABELS.PAYMENT_METHOD')}
											sx={{ width: "50%" }}>
											<MenuItem value="PO">{t('MENU_ITEMS.PURCHASE_ORDER')}</MenuItem>
											{optionKeys?.ccPayment === "Enabled" && <MenuItem value="CC">{t('MENU_ITEMS.CREDIT_DEBIT_CARDS')}</MenuItem>}
										</Select>
									</FormControl>
								</Box>

								{checkoutDetails.payment_details.payment_mode === "PO" && (
									<>
										<Box sx={{ display: "flex", gap: 2, alignItems: 'center', width: '100%' }}>

											<TextField
												fullWidth
												size="small"
												required
												sx={{ width: '50%' }}
												label={t("UI_TEXT.PURCHASE_ORDER_NUMBER")}
												value={checkoutDetails?.payment_details?.payment_details?.po_number ?? ""}
												error={!!errors["payment_details.payment_details.po_number"]}
												onChange={(e) =>
													handleFieldChange(
														"payment_details",
														"payment_details.po_number",
														e.target.value
													)
												}
												onBlur={() => {
													setTimeout(() => validatePaymentDetails(), 0);
												}}
											/>


											<Box
												sx={{
													borderRadius: "10px",
													background: "#eee",
													px: 1.5,
													py: 1,
													display: "flex",
													justifyContent: "flex-start",
													alignItems: "center",
													width: "100%",
													columnGap: 2,
												}}
											>
												<Button
													variant="contained"
													color="primary"
													size="small"
													startIcon={<CloudUploadIcon />}
													disabled={uploadedFile ? true : false}
													onClick={() => document.getElementById("fileInput").click()}
												>
													{t('FILE_UPLOAD.CHOOSE_FILE')}
												</Button>
												<Typography variant="body1" fontSize="11px">
													{uploadedFile ? uploadedFile?.name : t('UI_TEXT.ATTACH_PURCHASE_ORDER_FILE_OPTIONAL')}
												</Typography>
											</Box>

											<input
												type="file"
												id="fileInput"
												accept="application/pdf,image/jpeg,image/png,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
												style={{ display: "none" }}
												onChange={handleFileUpload}
											/>
										</Box>
									</>
								)}



								{uploadedFile && (
									<>
										<Typography variant="body2" fontSize={"12px"}>{t('UI_TEXT.ATTACHED_PURCHASE_ORDER_FILE')}</Typography>
										<Card
											variant="outlined"
											sx={{
												width: "100%",
												"&:hover": { backgroundColor: "action.hover" },
											}}
										>
											<CardContent
												sx={{
													display: "flex",
													alignItems: "center",
													justifyContent: "space-between",
													py: 1.5,
													"&:last-child": { pb: 1.5 },
												}}
											>
												<Box
													sx={{
														display: "flex",
														alignItems: "center",
														gap: 1,
														flex: 1,
													}}
												>
													<DocCardImage type={uploadedFile.type || "document"} />
													<Box sx={{ flex: 1, minWidth: 0 }}>
														<Typography
															variant="body2"
															sx={{
																fontWeight: 500,
																overflow: "hidden",
																textOverflow: "ellipsis",
																whiteSpace: "nowrap",
															}}
														>
															{uploadedFile.name || uploadedFile}
														</Typography>
														<Typography variant="caption" color="textSecondary">
															{uploadedFile.size
																? `${(uploadedFile.size / 1024).toFixed(1)} KB`
																: ""}
														</Typography>
													</Box>
													<Tooltip title={uploadedFile.type || t('UI_TEXT.FILE')}>
														<Chip
															label={uploadedFile.type || t('UI_TEXT.UNKNOWN')}
															size="small"
															variant="outlined"
															sx={{
																ml: 1,
																mr: 1,
																maxWidth: 120,
																whiteSpace: "nowrap",
																overflow: "hidden",
																textOverflow: "ellipsis",
															}}
														/>
													</Tooltip>
												</Box>

												<IconButton
													onClick={() => setUploadedFile(null)}
													size="small"
													color="error"
													sx={{ ml: 1 }}
												>
													<Delete fontSize="small" />
												</IconButton>
											</CardContent>
										</Card>
									</>
								)}
							</Box>
						</AccordionDetails>
					</Accordion>
				</Box>

				{/* Order Summary */}
				<Box width={isMobile ? "100%" : "35%"} sx={{ position: "sticky", top: DEFAULT_LAYOUT === "layout2" ? "150px" : "100px" }}>
					<Card sx={{ boxShadow: "0 0 6px 1px rgba(0,0,0,0.1)", borderRadius: '10px' }} data-tour="checkout-order-summary">
						<CardContent>
							<Box display="flex" alignItems="center" justifyContent="space-between" mb={1} flexWrap={"wrap"}>
								<Typography variant="h6" fontWeight="bold">
									{t('UI_TEXT.ORDER_SUMMARY')}
								</Typography>

							</Box>
							<Box display="flex" alignItems="center" justifyContent="flex-end" columnGap={1} my={1}>
								{canCreateOrderSchedule && <Button
									color="primary"
									size="small"
									variant="outlined"
									startIcon={<ScheduleOutlined />}
									onClick={handleScheduleButton}
								>
									{t('BUTTON.CREATE_ORDER_SCHEDULE')}
								</Button>}
								<Button size="small" variant="outlined" startIcon={<DownloadIcon />} onClick={() => {
									try {
										const rows = orderSummary.products.map((product) => ({
											product_name: product.product_name,
											product_number: product.product_number,
											quantity: product.ProductQty,
											price: Number(product.ProductPrice || 0).toFixed(2),
											line_total: Number(product.total || 0).toFixed(2),
										}));
										const headers = [
											t('TABLE_HEADERS.PRODUCT_NAME'),
											t('TABLE_HEADERS.PRODUCT_NUMBER'),
											t('TABLE_HEADERS.QUANTITY'),
											t('TABLE_HEADERS.PRICE'),
											t('TABLE_HEADERS.LINE_TOTAL'),
										];
										const csv = [headers.join(','), ...rows.map(r => [r.product_name, r.product_number, r.quantity, r.price, r.line_total].map(v => `"${String(v).replace(/"/g, '""')}"`).join(','))].join('\n');
										const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
										const url = URL.createObjectURL(blob);
										const a = document.createElement('a');
										a.href = url;
										const ts = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
										a.download = `order-summary-${ts}.csv`;
										document.body.appendChild(a);
										a.click();
										document.body.removeChild(a);
										URL.revokeObjectURL(url);
									} catch (e) {
										Swal.fire({ icon: 'error', title: t('ALERT_MESSAGES.EXPORT_FAILED'), text: t('ALERT_MESSAGES.COULD_NOT_EXPORT_ORDER_SUMMARY') });
									}
								}}>
									{t('BUTTON.EXPORT')}
								</Button>

							</Box>
							<Box sx={{ maxHeight: 200, overflowY: "auto" }}>
								<TableContainer>
									<Table>
										<TableHead>
											<TableRow>
												<TableCell>{t('TABLE_HEADERS.PART')}</TableCell>
												<TableCell align="center">{t('UI_TEXT.QTY')}</TableCell>
												<TableCell align="right">{t('TABLE_HEADERS.PRICE')}</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{/* Dynamically render products */}
											{orderSummary.products.map((product, index) => (
												<TableRow style={{ fontSize: '11px' }} key={`${product.product_id}-${product.machine_id}-${index}`}>
													<TableCell style={{ fontSize: '11px' }}>
														<Box>
															<Typography variant="body2" fontSize="11px">
																{product.product_name}
															</Typography>

															{product.promotion_applied && (
																<Typography variant="caption" color="success.main" fontWeight={600}>
																	Promo Applied: -{currencySymbol}
																	{Number(product.promo_discount || 0).toFixed(2)}
																</Typography>
															)}
														</Box>
													</TableCell>

													<TableCell align="center" style={{ fontSize: '11px' }}>
														x {product.ProductQty}
													</TableCell>

													<TableCell align="right" style={{ fontSize: '11px' }}>
														{currencySymbol}
														{Number(product.ProductPrice || 0).toFixed(2)}
													</TableCell>
												</TableRow>
											))}

											{/* Total Row */}
											<TableRow>
												<TableCell />
												<TableCell colSpan={1} align="center" style={{ fontSize: '12px', fontWeight: 'bold' }}>
													{t('TABLE_HEADERS.TOTAL')}
												</TableCell>
												<TableCell align="right" style={{ fontSize: '12px', fontWeight: 'bold' }}>
													{currencySymbol}
													{orderSummary.productTotalAfterLineDiscount.toFixed(2)}
												</TableCell>
											</TableRow>
										</TableBody>
									</Table>
								</TableContainer>
							</Box>
							{promotionAvailable && (
								<Box mt={2}>
									<Typography variant="subtitle2" fontWeight="bold" gutterBottom>
										Promotion Code
									</Typography>
									<Box display="flex" gap={1} flexDirection={isMobile ? "column" : "row"}>
										<TextField
											size="small"
											fullWidth
											value={promotionCode}
											label="Enter promotion code"
											disabled={promotionLoading || Boolean(appliedPromotion)}
											onChange={(event) => {
												setPromotionCode(event.target.value.toUpperCase());
												setPromotionError("");
											}}
											onKeyDown={(event) => {
												if (event.key === "Enter") {
													event.preventDefault();
													handleApplyPromotion();
												}
											}}
										/>
										{appliedPromotion ? (
											<Button size="small" variant="outlined" color="error" onClick={handleRemovePromotion}>
												{t('BUTTON.REMOVE')}
											</Button>
										) : (
											<Button
												size="small"
												variant="contained"
												onClick={handleApplyPromotion}
												disabled={promotionLoading || !promotionCode.trim()}
												sx={{ minWidth: 90 }}
											>
												{promotionLoading ? <CircularProgress size={18} color="inherit" /> : t('BUTTON.APPLY')}
											</Button>
										)}
									</Box>
									{promotionError && (
										<Alert severity="error" sx={{ mt: 1, py: 0 }}>
											{promotionError}
										</Alert>
									)}
									{appliedPromotion && (
										<Alert severity="success" sx={{ mt: 1, py: 0 }}>
											{appliedPromotion.promotion?.code} applied
										</Alert>
									)}
								</Box>
							)}
							<Box mt={2} display="flex" flexDirection="column" gap={0.75}>

								{appliedPromotion && (
									<Box display="flex" justifyContent="space-between" gap={2}>
										<Typography variant="body2">Promotion Discount</Typography>
										<Typography variant="body2">-{currencySymbol}{orderSummary.promoDiscount.toFixed(2)}</Typography>
									</Box>
								)}
								<Divider />
								<Box display="flex" justifyContent="space-between" gap={2}>
									<Typography variant="subtitle2" fontWeight="bold">Estimated Total</Typography>
									<Typography variant="subtitle2" fontWeight="bold">{currencySymbol}{orderSummary.total.toFixed(2)}</Typography>
								</Box>
							</Box>
							<Box px={1} my={1}>

								{/* <Typography my={2} variant="body2" fontSize={"11px"} color="text.secondary" marginTop="25px">
									Shipping & Taxes will be added to Final Invoice
								</Typography> */}

								<FormControlLabel
									control={
										<Checkbox required color="primary" checked={termsAccepted} onChange={handleCheckboxChange} />
									}
									label={
										<>
											{t('LABELS.ACCEPT')}{" "}
											<Link
												component="button"
												type="button"
												onClick={(e) => {
													e.preventDefault();
													handlePolicyOpen(termsDoc, "https://privacy.ithena.io/terms");
												}}
												color="primary"
												sx={{ cursor: "pointer" }}
											>
												{t('TITLES.TERMS_AND_CONDITIONS')}
											</Link>
										</>
									}
								/>
								{/* <Typography variant="body2" mt={1}>
									{t('UI_TEXT.VIEW_EULA_LIBRARY') || "Need to review the active EULAs?"}{" "}
									<Link
										component="button"
										type="button"
										onClick={(e) => {
											e.preventDefault();
											handleEulaView();
										}}
										color="primary"
										sx={{ cursor: "pointer" }}
									>
										{t('LABELS.EULA')}
									</Link>
								</Typography> */}
							</Box>



							{/* Place Order Button */}
							<Button
								variant="contained"
								color="primary"
								fullWidth
								disabled={!termsAccepted || !canPlaceOrder}
								onClick={handleCheckout}>
								{buttonLoading ? (
									<>{t('BUTTON.PLACING_ORDER')}</>
								) : buttonSuccess ? (
									<>
										<CheckCircleIcon sx={{ color: "white", marginRight: 1 }} />
										{t('BUTTON.PLACED')}
									</>
								) : (
									t('BUTTON.PLACED_ORDER')
								)}
							</Button>

							{!canPlaceOrder && (
								<Typography variant="body1" color="error" sx={{ mt: 1 }}>
									{t('UI_TEXT.YOU_ARE_NOT_AUTHORIZED_ORDER')} <br />
									{t('UI_TEXT.PLEASE_CONTACT_THE_CUTOMER_CARE_FOR_FURTHER_DETAILS')}
								</Typography>
							)}

							<Typography variant="body1" sx={{ fontSize: "11px", marginTop: "10px" }}>
								{t('UI_TEXT.PLEASE_CONTACT_THE_CUTOMER_CARE_FOR_FURTHER_DETAILS')}
							</Typography>
						</CardContent>
					</Card>
				</Box>
				{scheduleOpen && canCreateOrderSchedule && <ScheduleOrder
					open={scheduleOpen}
					setOpen={setScheduleOpen}
					selectedOrder={transformCartProducts(cartProducts)}
				/>}
				<ComplianceDescriptionModal
					open={policyModal.open}
					setOpen={(open) =>
						setPolicyModal((prev) => ({ open, doc: open ? prev.doc : null }))
					}
					document={policyModal.doc}
				/>
				<EulaLibraryModal
					open={eulaModalOpen}
					setOpen={setEulaModalOpen}
					documents={eulaDocs}
				/>
			</Box>
			{(buttonLoading || buttonSuccess) && <DefaultLoader />}
		</Box>
	);
};

export default Checkout;
